/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { ContactColumn } from "components/footer/main-footer/contact-column";
import { ResourcesColumn } from "components/footer/main-footer/resources-column";
import { SocialColumn } from "components/footer/main-footer/social-column";

const LangleyMainFooter = () => {
    return (
        <div className='main-footer'>
            <ContactColumn />
            <ResourcesColumn />
            <SocialColumn />
        </div>
    );
};

export { LangleyMainFooter };
